<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2025&nbsp;&nbsp;</span>PANEL&nbsp;GUESTS</p>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">
              <div class="pc-browser">VALSE 2022 PANEL GUESTS</div>
              <div class="mobile-browser">VALSE 2022<br/>PANEL GUESTS</div>
            </span>
          </div>
          <div class="item-content">
            <p class="content-null-info">敬请期待......</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Corporate"
    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/guster-banner.png");
  }
  .footer{
    position: fixed;
    bottom: 0;
  }
  @media screen  and (max-width: 800px){
    .content-item {
      margin: 70px auto;
      margin-bottom: 30px;
    }
    .program_banner{
      /*background-image: url("../../static/images/corporate_mobile_banner.jpg");*/
      background-size: cover;
      background-position: 28% 100%;
    }
    .item-title-content{
      position: relative;
      top:-38px;
    }
    .item-content{
      margin-top: -30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Corporate.vue